import { AlertOctagon, AlertTriangle, CheckCircle2 } from "lucide-react";
import { S } from "./lib";

// What the house rules found, in the order that matters.
export const OutreachFlags = ({ blocking = [], warnings = [], compact = false }) => {
  if (!blocking.length && !warnings.length) {
    return (
      <div className="flex items-center gap-1.5 text-[11.5px]" style={{ color: S.good }}
        data-testid="outreach-flags-clean">
        <CheckCircle2 className="w-3.5 h-3.5" /> No house-rule breaches
      </div>
    );
  }
  return (
    <div className="space-y-1.5" data-testid="outreach-flags">
      {blocking.map((f, i) => (
        <div key={`b${i}`} data-testid={`outreach-flag-block-${f.code || i}`}
          className="flex items-start gap-1.5 px-2.5 py-1.5 rounded-[7px] text-[11.5px] leading-snug"
          style={{ background: "#FFF1EC", border: "1px solid #F0C4B4", color: "#8E3A12" }}>
          <AlertOctagon className="w-3.5 h-3.5 mt-[1px] shrink-0" />
          <span><b className="font-bold">Blocks sending.</b> {f.message}</span>
        </div>
      ))}
      {!compact && warnings.map((f, i) => (
        <div key={`w${i}`} data-testid={`outreach-flag-warn-${f.code || i}`}
          className="flex items-start gap-1.5 px-2.5 py-1.5 rounded-[7px] text-[11.5px] leading-snug"
          style={{ background: "#FFFBEB", border: `1px solid ${S.border}`, color: S.ink2 }}>
          <AlertTriangle className="w-3.5 h-3.5 mt-[1px] shrink-0" style={{ color: S.accentInk }} />
          <span>{f.message}</span>
        </div>
      ))}
      {compact && warnings.length > 0 && (
        <div className="text-[11px]" style={{ color: S.ink3 }}>
          {warnings.length} thing{warnings.length > 1 ? "s" : ""} to look at
        </div>
      )}
    </div>
  );
};

export default OutreachFlags;
